import React from "react";
import { Link } from "react-router-dom";

import { Card, CardContent, Typography, CardHeader } from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import { NumericFormat } from "react-number-format";
import TableContainer from "@mui/material/TableContainer";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import RenderDate from "../../../Common/Date/RenderDate";

import RSAvatar from "../RSAvatar";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        padding: 12,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 18,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const exceptions = [
    {
        id: 1,
        title: "ESR - 1",
        days: 1,
        dateStart: "2021-01-01T11:03:47.166Z",
        dateEnd: "2022-12-31T11:03:47.166Z",
        status: "published",
    },
    {
        id: 2,
        title: "ESR - 2",
        days: 1,
        dateStart: "2021-01-01T11:03:47.166Z",
        dateEnd: "2022-12-31T11:03:47.166Z",
        status: "draft",
    },
    {
        id: 3,
        title: "ESR - 3",
        days: 1,
        dateStart: "2021-01-01T11:03:47.166Z",
        dateEnd: "2022-12-31T11:03:47.166Z",
        status: "published",
    },
    {
        id: 4,
        title: "ESR - 4",
        days: 1,
        dateStart: "2021-01-01T11:03:47.166Z",
        dateEnd: "2022-12-31T11:03:47.166Z",
        status: "published",
    },
];

function RosterCard() {
    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                avatar={<RSAvatar type="roster" />}
                title={
                    <Typography component="h3" className="card-header-title">
                        Rosters
                    </Typography>
                }
                subheader={
                    <Typography component="h4" className="card-header-subtitle">
                        <RenderDate date={""} />
                    </Typography>
                }
            />

            <CardContent>
                <TableContainer>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Roster</StyledTableCell>
                                <StyledTableCell>Period&nbsp;</StyledTableCell>
                                <StyledTableCell align="right">
                                    Hrs / PA&nbsp;
                                </StyledTableCell>
                                <StyledTableCell align="right">
                                    Status&nbsp;
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {exceptions.map((row, index) => (
                                <StyledTableRow key={index}>
                                    <StyledTableCell component="th" scope="row">
                                        <Link
                                            to={`/rs/rosters/${
                                                Number(row.id) || ""
                                            }`}
                                        >
                                            {row.title}
                                        </Link>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <RenderDate date={row.dateStart} />
                                        &nbsp;-&nbsp;
                                        <RenderDate date={row.dateEnd} />
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                        <NumericFormat
                                            value={row.days}
                                            decimalSeparator="."
                                            displayType="text"
                                            decimalScale={3}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                        {row.status}
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}

                            <StyledTableRow key="totals">
                                <StyledTableCell
                                    component="th"
                                    scope="row"
                                    sx={{ backgroundColor: "#FFFFFF" }}
                                ></StyledTableCell>
                                <StyledTableCell
                                    sx={{ backgroundColor: "#FFFFFF" }}
                                    colSpan={2}
                                >
                                    <Typography variant="subtitle2"></Typography>
                                </StyledTableCell>
                                <StyledTableCell
                                    align="right"
                                    sx={{ backgroundColor: "#FFFFFF" }}
                                ></StyledTableCell>
                            </StyledTableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
}

export default RosterCard;
